import { ComponentInstance, Dolan } from '@sapappgyver/appgyver-descriptors/lib/dolan/v4';
import editComponentInstanceById from './editComponentInstanceById';
import editViewById from '../../dolan/utils/editViewById';

export default function editComponentInstanceInViewById(
  dolan: Dolan,
  viewId: number,
  componentId: string,
  edit: (instance: ComponentInstance) => ComponentInstance,
): Dolan {
  return editViewById(dolan, viewId, (view) => {
    const oldRootComponent = view.layout.root_component;
    const newRootComponent = editComponentInstanceById(oldRootComponent, componentId, edit);
    return {
      ...view,
      layout: {
        root_component: newRootComponent,
      },
    };
  });
}
